"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBidActivityDto = instanceOfBidActivityDto;
exports.BidActivityDtoFromJSON = BidActivityDtoFromJSON;
exports.BidActivityDtoFromJSONTyped = BidActivityDtoFromJSONTyped;
exports.BidActivityDtoToJSON = BidActivityDtoToJSON;
exports.BidActivityDtoToJSONTyped = BidActivityDtoToJSONTyped;
/**
 * Check if a given object implements the BidActivityDto interface.
 */
function instanceOfBidActivityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('bidderId' in value) || value['bidderId'] === undefined)
        return false;
    if (!('bidderName' in value) || value['bidderName'] === undefined)
        return false;
    if (!('bidAmount' in value) || value['bidAmount'] === undefined)
        return false;
    if (!('bidDateTime' in value) || value['bidDateTime'] === undefined)
        return false;
    if (!('totalBids' in value) || value['totalBids'] === undefined)
        return false;
    if (!('isVendorBid' in value) || value['isVendorBid'] === undefined)
        return false;
    return true;
}
function BidActivityDtoFromJSON(json) {
    return BidActivityDtoFromJSONTyped(json, false);
}
function BidActivityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'bidderId': json['bidderId'],
        'bidderName': json['bidderName'],
        'bidAmount': json['bidAmount'],
        'bidDateTime': (new Date(json['bidDateTime'])),
        'totalBids': json['totalBids'],
        'bidderSequence': json['bidderSequence'] == null ? undefined : json['bidderSequence'],
        'isVendorBid': json['isVendorBid'],
    };
}
function BidActivityDtoToJSON(json) {
    return BidActivityDtoToJSONTyped(json, false);
}
function BidActivityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'bidderId': value['bidderId'],
        'bidderName': value['bidderName'],
        'bidAmount': value['bidAmount'],
        'bidDateTime': value['bidDateTime'].toISOString(),
        'totalBids': value['totalBids'],
        'bidderSequence': value['bidderSequence'],
        'isVendorBid': value['isVendorBid'],
    };
}
